import ReadSmore from './read-smore.js'
export default ReadSmore
